import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';
import { TypographyColorKeys } from '@decisiv/ui-components/lib/components/Typography/withColors';
import styled from 'styled-components';

type Props = {
  textAlign?: 'left' | 'start' | 'center' | 'end' | 'right';
  topLine?: React.ReactNode;
  color?: TypographyColorKeys;
  bottomLine?: string | React.ReactNode;
  truncate?: boolean;
  title?: string;
};

const FullWidthFlex = styled(Flex).attrs({ flexDirection: 'column' })`
  width: 100%;
  white-space: nowrap;
  text-align: ${(props: Props) => props.textAlign || 'start'};
` as typeof Flex;

export default function PlainTextCell({
  bottomLine = '',
  topLine,
  color,
  truncate = false,
  ...props
}: Props) {
  const text = topLine == null || topLine === '' ? '–' : topLine;
  return (
    <FullWidthFlex {...props}>
      <P color={color} as="span" truncate={truncate}>
        {text}
      </P>
      <P color={color} as="span" size="small" shade={1} truncate={truncate}>
        {bottomLine}
      </P>
    </FullWidthFlex>
  );
}
